module.exports = __webpack_public_path__ + "static/img/budget_brake_logo.f0a2abb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/budget_brake_logo.gif
// module id = 5zkV
// module chunks = 0